// src/api/user.js
import request from '@/utils/request'

// 获取用户信息
/** @param {{ skipApiCache?: boolean, skipAuthRedirect?: boolean, skipErrorDialog?: boolean }} [opts] */
export function getUserInfo(opts = {}) {
    return request({
        url: '/user/usersProfile/',
        method: 'get',
        skipApiCache: !!opts.skipApiCache,
        skipAuthRedirect: !!opts.skipAuthRedirect,
        skipErrorDialog: !!opts.skipErrorDialog,
    })
}

export function changeNameAuth(id, data) {
    return request({
        url: `/user/detail/${id}/changeRealName/`,
        method: 'post',
        data
    })
}

// 用户签到
export function sign() {
    return request({
        url: '/user/check-in/',
        method: 'post'
    })
}

export function getSignStatus() {
    return request({
        url: '/user/check-in/',
        method: 'get'
    })
}

export function realNameAuth(data) {
    return request({
        url: '/user/realNameAuth/',
        method: 'post',
        data
    })
}

export function getFundFlow(params) {
    return request({
        url: '/user/fundFlowList/',
        method: 'get',
        params
    })
}

// 获取推广奖励列表
export function getRewardList() {
    return request({
        url: '/user/referral/reward/list/',
        method: 'get'
    })
}

export function setUserBankCard(data) {
    return request({
        url: '/user/bankCard/',
        method: 'post',
        data
    })
}

export function getUserBankCard() {
    return request({
        url: '/user/bankCard/',
        method: 'get',
    })
}

export function delUserBankCard(data) {
    return request({
        url: `/user/bankCardDetail/${data.id}/`,
        method: 'delete',
        data
    })
}

export function editUserBankCard(data) {
    return request({
        url: `/user/bankCardDetail/${data.id}/`,
        method: 'put',
        data
    })
}

export function changeUserEmail(data) {
    return request({
        url: `/user/detail/${data.id}/changeEmail/`,
        method: 'post',
        data
    })
}

export function changeUserPassword(data) {
    return request({
        url: `/user/detail/${data.id}/changePassword/`,
        method: 'post',
        data
    })
}

export function changeUserPhoneNumber(data) {
    return request({
        url: `/user/detail/${data.id}/changePhoneNumber/`,
        method: 'post',
        data
    })
}

export function getUserPromotions(userId, level = 1, page = 1) {
    return request({
        url: `/user/detail/${userId}/getPromotions/`,
        method: 'get',
        params: {
            level,
            page
        }
    });
}

// 获取地址列表
export function getAddressList() {
    return request({
        url: '/user/addresses/',
        method: 'get'
    })
}

// 添加地址
export function addAddress(data) {
    return request({
        url: '/user/addresses/',
        method: 'post',
        data
    })
}

// 更新地址
export function updateAddress(id, data) {
    return request({
        url: `/user/addresses/${id}/`,
        method: 'put',
        data
    })
}

// 删除地址
export function deleteAddress(id) {
    return request({
        url: `/user/addresses/${id}/`,
        method: 'delete'
    })
}

// 获取提现记录
export function getWithdrawHistory(page = 1, pageSize = 10) {
    return request({
        url: '/user/withdraw/',
        method: 'get',
        params: {
            page,
            page_size: pageSize
        }
    })
}

// 提交提现申请
export function submitWithdraw(data) {
    return request({
        url: '/user/withdraw/',
        method: 'post',
        data,
        skipErrorDialog: true,
    })
}

// 绑定微信
export function setWechatAccount(data) {
    return request({
        url: `/user/detail/${data.user_id}/set_wechat_account/`,
        method: 'post',
        data
    })
}

// 绑定支付宝
export function setAlipayAccount(data) {
    return request({
        url: `/user/detail/${data.user_id}/set_alipay_account/`,
        method: 'post',
        data
    })
}

// 忘记密码
export function resetPassword(data) {
    return request({
        url: '/user/userInfo/forgotPassword/',
        method: 'post',
        data
    })
}

export function getUserLotteryRecords() {
    return request({
        url: '/api/v1/lottery/records/',
        method: 'get'
    })
}

// 添加中奖奖品邮寄地址
export function addPrizeAddress(data) {
    return request({
        url: `/api/v1/lottery/records/${data.id}/update_shipping_info/`,
        method: 'post',
        data
    })
}

/** 云家邀请阶梯 / 云盾恢复进度 */
export function getYunjiaInviteLadder() {
    return request({
        url: '/user/yunjia/invite/ladder/',
        method: 'get',
    })
}

/** 领取云家邀请阶梯奖励 */
export function claimYunjiaInviteReward(data) {
    return request({
        url: '/user/yunjia/invite/claim/',
        method: 'post',
        data,
    })
}

/** 用户间转账（云盾等） POST /user/yunjia/transfer/ */
export function yunjiaTransfer(data) {
    return request({
        url: '/user/yunjia/transfer/',
        method: 'post',
        data,
    })
}

/** 转账收款人预览 GET /user/yunjia/transfer/lookup/ */
export function yunjiaTransferLookup(params) {
    return request({
        url: '/user/yunjia/transfer/lookup/',
        method: 'get',
        params,
    })
}

/** 云盾资产预约申报 GET /user/yunjia/shield-apply/（公开，无需登录/实名） */
export function getYunjiaShieldApply(params) {
    return request({
        url: '/user/yunjia/shield-apply/',
        method: 'get',
        params,
        skipAuthRedirect: true,
        skipErrorDialog: true,
    })
}

/** 云盾资产预约申报 POST /user/yunjia/shield-apply/（公开，无需登录/实名） */
export function submitYunjiaShieldApply(data) {
    return request({
        url: '/user/yunjia/shield-apply/',
        method: 'post',
        data,
        skipAuthRedirect: true,
        skipErrorDialog: true,
    })
}

/** 查询是否已设置支付密码 GET /user/pay-password/ */
export function getPayPasswordStatus() {
    return request({
        url: '/user/pay-password/',
        method: 'get',
    })
}

/** 首次设置支付密码 POST /user/pay-password/ */
export function setPayPassword(data) {
    return request({
        url: '/user/pay-password/',
        method: 'post',
        data,
    })
}

/** 修改支付密码 PUT /user/pay-password/ */
export function changePayPassword(data) {
    return request({
        url: '/user/pay-password/',
        method: 'put',
        data,
    })
}
